import StudentSection from './StudentSection';
export default StudentSection;
export * from './StudentSection';
